import { useState, useRef } from 'react';
import propTypes from 'prop-types';
import classNames from 'clsx';
import Menu from './Menu';
import { useOnClickOutside } from './hooks';
import css from './drop-down-menu.module.scss';

/**
 * Dropdown menu component Renders a list of items in a dropdown
 * @param {object} button - The attributes to be applied to the button
 * @param {array} items - The items to be displayed
 * @param {string} className - The class to be applied
 */
const DropDownMenu = ({ button, items, className }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const ref = useRef();

  useOnClickOutside(ref, () => setMenuOpen(false));

  return (
    <div
      data-testid="dropDownMenu"
      className={classNames([css.container], { [css.menuOpen]: isMenuOpen })}
      ref={ref}
    >
      <button
        onClick={() => setMenuOpen(!isMenuOpen)}
        className={classNames(button.className, css.button)}
      >
        {button.title}
      </button>
      {isMenuOpen && (
        <Menu
          items={items}
          onClose={() => setMenuOpen(false)}
          className={classNames(css.menu, className)}
        />
      )}
    </div>
  );
};

DropDownMenu.propTypes = {
  className: propTypes.string,
  items: propTypes.array,
  button: propTypes.shape({
    title: propTypes.any,
  }),
};

export default DropDownMenu;
